import React, { FC } from 'react';
import { useNavigate } from 'react-router';

import { url } from 'helpers';
import { useLang } from 'hooks';
import { Modal, ResultIcon } from 'components/ui';
import { Nullish } from 'types/common';
import { ModalBaseProps } from 'types/components';

import styles from './styles.module.css';

type ErrorModalProps = ModalBaseProps & {
  error?: Nullish<string>;
};

const ErrorModal: FC<ErrorModalProps> = ({ error, ...props }) => {
  const lang = useLang();
  const navigate = useNavigate();

  return (
    <Modal
      className={styles.errorModal}
      title={(
        <>
          <ResultIcon className={styles.errorModal__icon} type="error" />
          <div>{lang.get('invoicePayment.errorModal.title')}</div>
        </>
      )}
      caption={error ?? lang.get('invoicePayment.errorModal.caption')}
      okText={lang.get('common.actions.ok')}
      okButtonProps={{ block: true }}
      cancelButtonProps={{ hidden: true }}
      closable={false}
      maskClosable={false}
      onOk={() => navigate(url.toDashboard())}
      {...props}
    />
  );
};

export default ErrorModal;
